import { useCallback, useEffect, useMemo, useState } from 'react';
import { fetchCopilotPreviewV2 } from '../api/CopilotPreviewV2Api';
import { FAILED, PENDING, SUCCEEDED, UNINITIALIZED } from '../types/requestStatus';
import { getLocale } from 'I18n/utils/internal/light/intlFormatters';
import { getMapV1DataToV2 } from '../components/CopilotPreview/internalV2/utils/mapV1DataToV2';
export const useGetCopilotPreview = (previewKey, previewSource, copilotAction) => {
  const [requestStatus, setRequestStatus] = useState(UNINITIALIZED);
  const [preview, setPreview] = useState(null);
  const [error, setError] = useState(null);
  const mapDataToV2 = useCallback(() => {
    return getMapV1DataToV2(copilotAction);
  }, [copilotAction]);
  const requestData = useMemo(() => {
    const mappedData = mapDataToV2();
    return {
      previewKey,
      previewSource,
      message: mappedData.message,
      context: Object.assign({
        locale: getLocale()
      }, mappedData.context)
    };
  }, [mapDataToV2, previewKey, previewSource]);
  useEffect(() => {
    setRequestStatus(PENDING);
    fetchCopilotPreviewV2(requestData).then(setPreview).catch(e => {
      setError(e);
      setRequestStatus(FAILED);
    }).finally(() => setRequestStatus(SUCCEEDED));
  }, [requestData]);
  return {
    preview,
    requestStatus,
    error
  };
};